import React from "react";

export const CorporatePPA = [
  <>
    <h4 className="slideTitle">Corporate power purchase agreements (PPA)</h4>
    <div className="slideContainer slide_solidColour">
      <div className="colLeft col50">
        <p>
          <strong>The emerging preference for buying renewable power</strong>
        </p>
        <p>
          Shell can partner with you for the most suitable corporate power
          purchase agreement (PPA) for your company.
        </p>
        <ul className="shell_bullets_list">
          <li>
            You can access a fast-growing global portfolio of renewable power
            supplies from existing and under-development assets owned by us and,
            occasionally, third parties.
          </li>
          <li>We can handle the power operations and balancing for you.</li>
          <li>
            You can fix and manage the power price along the tenure of the PPA.
          </li>
          <li>
            Corporate PPAs may enable you to contribute to the development of
            new renewable assets.
          </li>
        </ul>
      </div>
      <div className="colRight col50 solidColourContainer align-self-start">
        <h4 class="slideTitle">Limejump</h4>
        <p>
          remotely optimises renewable generation assets and trade these in
          markets across UK & Europe.
        </p>
        <p>1,4 TWh in power sales, and 535 sites optimized in 2020.</p>
      </div>
    </div>
  </>,
  <>
    <h4 className="slideTitle">Corporate power purchase agreements (PPA)</h4>
    <div className="slideContainer slide_solidColour text-center">
      <img
        src="images/PPA-hiw.JPG"
        width="900px"
        height="auto"
        className="mx-auto"
      />
    </div>
  </>,
];
